// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import {
  Card,
  CardMedia,
  CardHeader,
  Divider,
  CardContent,
  Box,
  Typography,
  List,
  ListItem
} from '@mui/material';
import WhatsNewIcon from "../../assets/img/card-img-3.svg";

const WhatsNewCard = () => {
  return (
    <Card
      sx={{
        p: 3,
        mb: 3,
        minHeight: 450,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
    >
      <CardMedia
        component="img"
        sx={{ width: 100, ml: 2 }}
        image={WhatsNewIcon}
      />
      <CardHeader
        title="What's New?"
        subheader={""}
        titleTypographyProps={{
          align: "left",
        }}
        subheaderTypographyProps={{
          align: "left",
        }}
      />
      <Divider variant="middle" />
      <CardContent>
        <List
          sx={{
            listStyleType: "disc",
            "& .MuiListItem-root": {
              display: "list-item",
            },
          }}
        >
          <ListItem sx={{ mt: -2 }}>
            {" "}
            <Typography variant="subtitle1" align="left">
              Learn more about our latest training materials on our{" "}
              <a
                style={{
                  textDecoration: "none",
                  fontWeight: "bold",
                  color: "#000000",
                }}
                href="https://lms.wso2.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LMS
              </a>
            </Typography>
          </ListItem>
          <ListItem sx={{ mt: -1 }}>
            <Typography variant="subtitle1" align="left">
              Sign up to our latest{" "}
              <a
                style={{
                  textDecoration: "none",
                  fontWeight: "bold",
                  color: "#000",
                }}
                href="https://wso2.com/training/certification/"
                target="_blank"
                rel="noopener noreferrer"
              >
                certifications
              </a>
            </Typography>
          </ListItem>
          <ListItem sx={{ mt: -1, mb: -3 }}>
            <Typography variant="subtitle1" align="left">
              WSO2 partner employees can now sign up to certification exams via
              the Partner Portal
            </Typography>
          </ListItem>
        </List>
      </CardContent>
    </Card>
  );
};

export default WhatsNewCard;
